import { render } from "./AppointmentReceivedtView.vue?vue&type=template&id=b4251312&scoped=true"
import script from "./AppointmentReceivedtView.vue?vue&type=script&lang=js"
export * from "./AppointmentReceivedtView.vue?vue&type=script&lang=js"

import "./AppointmentReceivedtView.vue?vue&type=style&index=0&id=b4251312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4251312"]])

export default __exports__